import {PaletteColorsEnum} from '../../../../../libs/shared/core/src/models/api/paletteModel';
import {RuleBundleCategoriesEnum} from '../../../../settings/rules/list/ruleBundleCategory';

export interface OnboardingCarouselTagTemplate {
  name: string;
  emoji?: string;
  color: PaletteColorsEnum;
}

export const onboardingCarouselTagTemplates = {
  'customer-conversation': {
    name: 'Customer conversation',
    emoji: '🙋',
    color: PaletteColorsEnum.BLUE,
  },
  urgent: {
    name: 'Urgent',
    emoji: '🚨',
    color: PaletteColorsEnum.RED,
  },
  newsletter: {
    name: 'Newsletter',
    emoji: '🗞️',
    color: PaletteColorsEnum.GREY,
  },
  billing: {
    name: 'Billing',
    emoji: '💵',
    color: PaletteColorsEnum.YELLOW,
  },
  'sla-breach': {
    name: 'SLA breach',
    emoji: '🔥',
    color: PaletteColorsEnum.ORANGE,
  },
  'general-inquiry': {
    name: 'General inquiry',
    emoji: '🥗',
    color: PaletteColorsEnum.GREEN,
  },
} as const satisfies Record<string, OnboardingCarouselTagTemplate>;

type OnboardingCarouselTagTemplateId = keyof typeof onboardingCarouselTagTemplates;

export interface OnboardingCarouselWorkflowTemplate {
  name: string;
  previewName?: string;
  type: RuleBundleCategoriesEnum;
  tags?: ReadonlyArray<OnboardingCarouselTagTemplateId>;
  hasBusinessHours?: boolean;
}

export const onboardingCarouselWorkflowTemplates = {
  'tag-customer-communications': {
    name: 'Tag all customer communications',
    previewName: 'Auto-tag',
    type: RuleBundleCategoriesEnum.TAG,
    tags: ['customer-conversation', 'sla-breach'],
  },
  'assign-customer-conversation-to-group': {
    name: 'Assign within a teammate group',
    previewName: 'Auto-assign',
    type: RuleBundleCategoriesEnum.ASSIGN,
    tags: ['customer-conversation'],
  },
  'sla-unreplied-customer-conversation': {
    name: 'Internal reminders on unreplied customer conversations',
    previewName: 'Reply time warning',
    type: RuleBundleCategoriesEnum.SLA,
    tags: ['sla-breach'],
    hasBusinessHours: true,
  },
  'tag-general-communications': {
    name: 'Tag general inquiries, invoices & urgent conversations',
    previewName: 'Auto-tag',
    type: RuleBundleCategoriesEnum.TAG,
    tags: ['urgent', 'general-inquiry', 'billing', 'newsletter'],
  },
  'archive-invites': {
    name: 'Archive accepted calendar invites',
    previewName: 'Auto-archive',
    type: RuleBundleCategoriesEnum.ARCHIVE,
  },
} as const satisfies Record<string, OnboardingCarouselWorkflowTemplate>;

export type OnboardingCarouselWorkflowTemplateId = keyof typeof onboardingCarouselWorkflowTemplates;
